"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExtraForProperty = exports.extraForPropertyDefinition = void 0;
exports.extraForPropertyDefinition = {
    view: { label: 'Extra for' },
    constraints: [
        {
            name: 'stencils',
            argument: [
                'episode-video',
                'film',
                'show',
                'event-profile',
            ],
        },
    ],
    type: 'asset',
    multiple: true,
    name: 'extra-for',
};
const isExtraForProperty = (prop) => {
    return prop.name === exports.extraForPropertyDefinition.name;
};
exports.isExtraForProperty = isExtraForProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXh0cmEtZm9yLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvZXh0cmEtZm9yLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsMEJBQTBCLEdBQUc7SUFDeEMsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLFdBQVcsRUFBRTtJQUM1QixXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRTtnQkFDUixlQUFlO2dCQUNmLE1BQU07Z0JBQ04sTUFBTTtnQkFDTixlQUFlO2FBQ2hCO1NBQ0Y7S0FDRjtJQUNELElBQUksRUFBRSxPQUFPO0lBQ2IsUUFBUSxFQUFFLElBQUk7SUFDZCxJQUFJLEVBQUUsV0FBVztDQUNjLENBQUE7QUFJMUIsTUFBTSxrQkFBa0IsR0FBRyxDQUFDLElBQWtCLEVBQTRCLEVBQUU7SUFDakYsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLGtDQUEwQixDQUFDLElBQUksQ0FBQTtBQUN0RCxDQUFDLENBQUE7QUFGWSxRQUFBLGtCQUFrQixzQkFFOUIifQ==